import * as React from "react"
import { cn } from "../../lib/utils"

const DateInput = React.forwardRef(({ className, ...props }, ref) => {
  const inputRef = React.useRef(null)
  
  // Combine refs
  React.useImperativeHandle(ref, () => inputRef.current)
  
  const handleClick = (e) => {
    // Open the date picker when clicking anywhere on the input
    if (inputRef.current) {
      try {
        inputRef.current.showPicker()
      } catch (error) {
        // Fallback for browsers that don't support showPicker
        inputRef.current.focus()
      }
    }
  }

  return (
    <input
      type="date"
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm cursor-pointer",
        className
      )}
      ref={inputRef}
      onClick={handleClick}
      {...props}
    />
  )
})
DateInput.displayName = "DateInput"

export { DateInput }
